import { render } from "./usermenu.vue?vue&type=template&id=38b0920f&scoped=true"
import script from "./usermenu.vue?vue&type=script&lang=js"
export * from "./usermenu.vue?vue&type=script&lang=js"

import "./usermenu.vue?vue&type=style&index=0&id=38b0920f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b0920f"]])

export default __exports__